import React, { useEffect, useState } from "react";
import ProductList from "../../components/DynamicList&Grid/DynamicListGrid";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";

const ProjectManagement = () => {
  const projectData = getStoredData()?.[1] || {};

  const {
    TitleProject,
    AdminProject,
    RedirectAdminProject,
    ApiProject,
  } = projectData;

  const { apiData, loading, error } = useApiData(["project"]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (apiData?.project && Array.isArray(apiData.project)) {
      setProjects(apiData.project);
    } else {
      setProjects([]);
    }
  }, [apiData]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="ProjectManagement">
      <h1>{TitleProject} Management</h1>
        <ProductList
          products={projects}
          fields={AdminProject}
          redirect={RedirectAdminProject}
          deleteApi={ApiProject}
          showEdit={true}
          showDelete={true}
          createPath={`/${TitleProject?.toLowerCase()}/create`}
        />
    </div>
  );
};

export default ProjectManagement;
